import { useEffect, useState } from "react";
import moment from "moment";

import {PERIODTIMEOBJ} from "@/pages/dashboard/_config/constant";
import { SortBy } from 'tea-component/es/table/addons';
import { useLocal } from "@/pages/dashboard/utils/customHook";
import { formatFilterValues } from "@/pages/dashboard/utils/utils";
import {  getInameRevenueTable } from '@/pages/dashboard/services/monetization';
/**
 * 按照接口区分为不同model
 * hook名称规范：use+接口名称+Data
 * @param props 父页面所有props
 * @param props: timeZone 时区信息，realtime特有
 * @param props: dispatch dva  dispatch方法
 * @returns
 * 获取数据的逻辑：dva中有数据则取dva中的数据，否则自己通过接口请求
 */

const pcConsoleIngameTableModel = (props: any, formValue: any, dispatch: any, filterLoading: boolean, accumulated: string[], paging: {}, sort: SortBy[], segmentValue: string, filterConfirm: boolean) => {
    const { gameCode } = props;
    const { isEN } = useLocal();
    const [componentData, setComponentData] = useState({
        aggregation: [],
        metrics_list: [],
        row_count: 0,
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    // 筛选器、分页、排序改变的时候
    useEffect(() => {
        if (filterLoading) return;
        getRetentionDataFunc();
    }, [formValue, JSON.stringify(paging),JSON.stringify(sort),accumulated ])

    const getRetentionDataFunc = () => {
        const { filterValue, timeType } = formValue
        const { rangeTime, ...filters } = filterValue
        const accumulation = {
            by_zone: accumulated.includes('zone'),
            by_region: accumulated.includes('region'),
            by_country: accumulated.includes('country'),
            by_channel: accumulated.includes('channel'),
            by_system: accumulated.includes('system'),
            by_language: accumulated.includes('language'),
        }
        let desc = sort?.[0]?.order === 'desc' || (!sort[0]);
        let sorted_by = sort?.[0]?.by?.replace(segmentValue, '') || 'date'
        const params = {
            game_code: gameCode,
            filters: formatFilterValues(filters),
            start_date: moment(rangeTime?.[0]).format('YYYY-MM-DD'),
            end_date: moment(rangeTime?.[1]).format('YYYY-MM-DD'),
            accumulation,
            period: PERIODTIMEOBJ[timeType],
            desc: filterConfirm ? true : desc,
            sorted_by: filterConfirm ? 'date' : sorted_by,
            page: filterConfirm ? 1 : paging?.pageIndex,
            page_size: filterConfirm ? 10 : paging?.pageSize,
        }
        setLoading(true);
        getInameRevenueTable(params, isEN ? 'en' : 'zh').then((result: any) => {
            setLoading(false);
            setError(false)
            setComponentData(result);
            dispatch({
                type: "engagementServiceData/getCountryComprisionTableFunc",
                payload: {
                    result
                }
            });
        }).catch((err: any) => {
            setError(true)
            setLoading(false);
        })
    }
    return {
        // nodata 不在此封装，因为可能是接口的个别项目nodata
        componentData,
        loading,
        error,
    }
}

export default pcConsoleIngameTableModel;
